<template lang="pug">
  #app
    ServiceLayout(
      v-if="$route.meta && $route.meta.service"
    )
      transiton(
        name="route"
      )
        router-view

    LayoutDefault(
      v-else
    )
      TheSidebar(
        slot="sidebar"
      )
        Logo(
          slot="logo"
        )

        Menu(
          slot="menu"
        )

        Profile

      router-view
  </div>
</template>

<script>
import Menu from './components/sidebar/Menu.vue';
import Logo from './components/sidebar/Logo.vue';
import Profile from './components/sidebar/Profile.vue';
import TheSidebar from './components/sidebar/TheSidebar.vue';
import LayoutDefault from './layouts/default.vue';
import ServiceLayout from './layouts/service.vue';

export default {
  name: 'App',

  beforeMount () {
    this.$store.dispatch('user/getUser');
  },

  components: {
    ServiceLayout,
    LayoutDefault,
    TheSidebar,
    Logo,
    Profile,
    Menu,
  },
};
</script>


<style lang="scss">
@import url('./assets/styles/reset.css');
@import url('./assets/fonts/stylesheet.css');

body {
  background-color: #F0F1F6;
}

#app {
  font-family: 'Avenir Next Cyr';
}

.route-enter-active, .route-leave-active {
  transition: opacity ease-in-out .2s;
}
.route-enter, .route-leave-to /* .fade-leave-active до версии 2.1.8 */ {
  opacity: 0;
}
</style>
